import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    messageId: Number,
    threadId: Number
  }

  static targets = ["FeedbackModal"]

  openFeedbackModal(){
    this.FeedbackModalTarget.classList.remove("hidden");
  }

  hideFeedbackModal(){
    this.FeedbackModalTarget.classList.add("hidden");
  }

  rate(event) {
    const icon = event.currentTarget
    const feedback = icon.dataset.aiMessageFeedbackFeedbackValueParam

    fetch(`/ai_assistant/threads/${this.threadIdValue}/messages/rate`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: JSON.stringify({
        feedback_rating: feedback,
        message_id: this.messageIdValue
      })
    }).then(response => {
      if (response.ok) {
        this.element.querySelectorAll(".feedback-icon").forEach(el => {
          el.style.color = "#ccc"
          el.classList.remove("selected")
        })
        icon.style.color = "#1B5599"
        icon.classList.add("selected")
      }
    })
  }

  setSmileRating(event) {
    const value = parseInt(event.params.setSmileRating, 10)
    document.getElementById("smile-rating-value").value = value

    document.querySelectorAll(".aq-smile-rating-button").forEach((button) => {
      const buttonValue = parseInt(button.dataset.aiMessageFeedbackSetSmileRatingParam, 10)
      button.classList.toggle("active", buttonValue === value)
    })
  }

  submitFeedback() {
    const rating = parseInt(document.getElementById("smile-rating-value").value, 10)
    const issues = Array.from(document.querySelectorAll(".issue-checkbox"))
    .filter(checkbox => checkbox.checked)
    .map(checkbox => checkbox.value)
    const comment = document.getElementById("feedback-comment").value;

    fetch(`/ai_assistant/threads/${this.threadIdValue}/feedbacks`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: JSON.stringify({
        feedback: {
          smiley_rating: rating,
          issues: issues,
          comment: comment
        }
      })
    })
    .then(response => {
      if (response.ok) {
        this.hideFeedbackModal();
        alert("Thank you for your feedback!");
      } else {
        return response.json().then(data => {
          console.error("Feedback submission failed:", data);
          alert("Something went wrong. Please try again.");
        });
      }
    })
    .catch(error => {
      console.error("Network error:", error);
      alert("Network error. Please try again.");
    });
  }

}